import { useTranslation } from 'react-i18next';
import { Button } from '@peacecover/component';
import { LockFill, Plus } from '@peacecover/icon';
import type { components } from '../../../types/schema';

type ChatRoomUserPicture = components['schemas']['ApiV1BettieChatRoomUserPicture'] & {
  nickname?: string;
};

interface BettieCenterProfileImageProps {
  currentProfilePicture: ChatRoomUserPicture | null;
  onApplyProfilePicture: () => void;
  onClickAddProfileImage: () => void;
  isApplyLoading: boolean;
}

const BettieCenterProfileImage = ({
  currentProfilePicture,
  onApplyProfilePicture,
  onClickAddProfileImage,
  isApplyLoading
}: BettieCenterProfileImageProps) => {
  const { t } = useTranslation();
  const isVisible = currentProfilePicture?.visibility ?? true;
  const isCurrentProfile = currentProfilePicture?.type === 'current';
  const nicknameToShow = currentProfilePicture?.nickname;

  return (
    <div className="mt-[36px]">
      <div className="relative">
        {currentProfilePicture?.pictureUrl ? (
          <img
            src={currentProfilePicture.pictureUrl}
            alt="profile"
            className="rounded-full w-[248px] h-[248px] object-cover"
          />
        ) : (
          <button
            type="button"
            className="p-[73px] rounded-full bg-secondary-light dark:bg-secondary-dark"
            onClick={onClickAddProfileImage}
          >
            <Plus size={102} className="text-on-secondary" />
          </button>
        )}
        {nicknameToShow && (
          <p className="absolute bottom-[14px] left-[50%] translate-x-[-50%] text-[13px] leading-[16px] text-[rgba(255,255,255,0.71)] text-shadow-[0_0_4px_rgba(0,0,0,0.26)]">
            by {nicknameToShow}
          </p>
        )}
        {!isVisible && (
          <div className="absolute bottom-[4px] right-[30px] rounded-full bg-disable border-[1.8px] border-background-elevated px-[7px] pt-[6.5px] pb-[7.5px]">
            <LockFill size={21.6} className="text-text-main-lv2" />
          </div>
        )}
      </div>
      <div className="flex items-center justify-center">
        {!currentProfilePicture?.pictureUrl ? (
          <p className="text-[13px] leading-[16px] text-text-main-lv4 text-center mt-[29px] h-[24px]">
            {t('BettieChangeProfile.hasNoProfile')}
          </p>
        ) : isCurrentProfile ? (
          <p className="text-[13px] leading-[16px] text-text-main-lv4 text-center mt-[29px] h-[24px] mb-[4px]">
            {t('BettieChangeProfile.isCurrentProfile')}
          </p>
        ) : (
          <Button
            size="medium"
            className="px-[18px] text-[14px] font-semibold mt-[18px]"
            onClick={onApplyProfilePicture}
            disabled={isApplyLoading}
          >
            {t('BettieChangeProfile.changeProfile')}
          </Button>
        )}
      </div>
    </div>
  );
};

export default BettieCenterProfileImage;
